import Section from "../components/Section";
import PageBackground from "../components/PageBackground";
import {Button} from "../components/Button";
import docsBackground from '../assets/backgrounds/documents.jpg';
import {BottomNavigator} from "../components/Navbar";
import {useTranslation} from "react-i18next";
import ScrollReveal from "../components/ScrollReveal";

const DocumentsPage = ({embedded = false}) => {
    const {t} = useTranslation();

    return (
        <div className={'Page DocumentsPage'}>
            <Section className={'TopSection'}>
                <PageBackground src={docsBackground}/>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'left'}>
                        {t('documents.heading')}
                    </ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={80} variant={'up'}>
                        {t('documents.title')}
                    </ScrollReveal>
                    <ScrollReveal as={'p'} threshold={0.12} delay={140} variant={'right'}>
                        {t('documents.lavita_whitepaper')}
                    </ScrollReveal>

                    <ScrollReveal threshold={0.12} delay={180} variant={'scale'}>
                        <Button color={'green'}
                                size={'large'}
                                href={'https://www.lavita.ai/pdfs/Lavita_white_paper_latest.pdf'}
                                target={'_blank'}
                        >
                            {t('documents.download')}
                        </Button>
                    </ScrollReveal>
                </div>
            </Section>

            {
                !embedded &&
                <BottomNavigator
                    prev={{
                        to: '/roadmap',
                        title: t('navbar.roadmap')
                    }}
                    next={{
                        to: '/',
                        title: t('navbar.home')
                    }}/>
            }
        </div>
    )
};

export default DocumentsPage;
